import * as React from "react";
const SvgFiRrPlate = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-plate_svg__a)">
      <path
        fill="#062147"
        d="M12 24A12.013 12.013 0 0 1 0 12C.63-3.908 23.373-3.9 24 12a12.01 12.01 0 0 1-12 12m0-22A10.01 10.01 0 0 0 2 12c.525 13.257 19.477 13.253 20 0A10.01 10.01 0 0 0 12 2m8 10a1 1 0 1 0-2 0c-.251 7.93-11.749 7.928-12 0a6.006 6.006 0 0 1 6-6 1 1 0 1 0 0-2 8.01 8.01 0 0 0-8 8c.376 10.588 15.626 10.586 16 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-plate_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPlate;
